import { Card } from "@shopify/polaris";
import "./ReusableElementCard.css";
import InspectionElement from "../../types/InspectionElement";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { ReusableDocumentRow } from "./ReusableDocumentRow";
import { getValidUntilDate } from "../../helpers/utils";

type ReusableElementCardProps = {
    inspectionElement: InspectionElement;
    updateValidReuseDocuments: (element: InspectionElement) => void;
}

export default function ReusableElementCard({
    inspectionElement,
    updateValidReuseDocuments
}: ReusableElementCardProps) {
    const { t } = useTranslation("common");
    const [reusableElement, setReusableElement] = useState<InspectionElement>(inspectionElement);
    const [validForReuse, setValidForReuse] = useState<boolean>(inspectionElement.ValidForReuse ?? true);

    useEffect(() => {
        setReusableElement(inspectionElement);
    }, [inspectionElement]);

    const handleCheckboxClick = (reusableElement: InspectionElement) => {
        setValidForReuse(!validForReuse);
        updateValidReuseDocuments(reusableElement);
    }

    const getDocumentList = () => {
        return reusableElement.Documents.map((document) => {
            return (
                <ReusableDocumentRow key={document.id} document={document} />
            );
        });
    }

    return (
        <Card>
            <div key={reusableElement.Id} className="reusable-element">
                <div id="reusable-element-header" className="reusable-element-header">
                    <div id="reusable-element-title" className="reusable-element-title">{reusableElement.Name}</div>
                    <div id={`valid-reuse-${reusableElement.Id}`} className="valid-reuse">
                        <input type="checkbox" id={`valid-reuse-checkbox-${reusableElement.Id}`} className="valid-reuse-checkbox" checked={validForReuse} onChange={(e) => handleCheckboxClick(reusableElement)} />
                        <label htmlFor={`valid-reuse-checkbox-${reusableElement.Id}`} className="valid-reuse-label">{t("reuseDocuments.validReuse")}</label>
                    </div>
                </div>
                <div id="reusable-element-list" className="reusable-element-list">
                    {getDocumentList()}
                </div>
                <div id="reusable-element-footer" className="reusable-element-footer">
                    <div id="element-added-by" className="reusable-element-text footer-text">
                        <div className="footer-title">{t("reuseDocuments.addedBy")}</div>
                        <div className="footer-value">{reusableElement.Documents[0].metadata["asset-uploaded-by"]}</div>
                    </div>
                    <div id="element-valid-until" className="reusable-element-text footer-text">
                        <div className="footer-title">{t("reuseDocuments.validUntil")}</div>
                        <div className="footer-value">{getValidUntilDate(reusableElement.Documents[0].metadata["reusable-expiry"], t)}</div>
                    </div>
                </div>
            </div>
        </Card>
    );
}